module.exports = __webpack_public_path__ + "img/bg.3f02d090.png";